import {
    REQUEST_PRODUCTS,
    FETCH_PRODUCTS_SUCCESS,
    FETCH_PRODUCTS_FAILURE,
    REQUEST_PRODUCTS_BY_VENDOR,
    FETCH_PRODUCTS_BY_VENDOR_SUCCESS,
    FETCH_PRODUCTS_BY_VENDOR_FAILURE,
    SELECT_PRODUCT,
    RESET_CURRENT_PRODUCT,
    CLEAR_CURRENT_PRODUCT,
    SET_GROUP_CATEGORY,
    REQUEST_CREATING_PRODUCT,
    CREATE_PRODUCT_SUCCESS,
    CREATE_PRODUCT_FAILURE,
    REQUEST_EDITING_PRODUCT,
    EDIT_PRODUCT_SUCCESS,
    EDIT_PRODUCT_FAILURE,
    REQUEST_EDITING_MULTI_PRODUCT,
    EDIT_MULTI_PRODUCT_SUCCESS,
    EDIT_MULTI_PRODUCT_FAILURE,
    REQUEST_PRODUCT_DETAIL,
    FETCH_PRODUCT_DETAIL_SUCCESS,
    FETCH_PRODUCT_DETAIL_FAILURE,
    REQUEST_DISPLAY_CATEGORIES,
    FETCH_DISPLAY_CATEGORIES_SUCCESS,
    FETCH_DISPLAY_CATEGORIES_FAILURE,
    REQUEST_EDIT_DISPLAY_CATEGORIES,
    EDIT_DISPLAY_CATEGORIES_SUCCESS,
    EDIT_DISPLAY_CATEGORIES_FAILURE,

    REQUEST_GROUPS,
    FETCH_GROUPS_SUCCESS,
    FETCH_GROUPS_FAILURE,
    SELECT_GROUP,
    RESET_CURRENT_GROUP,
    REQUEST_CREATING_GROUP,
    CREATE_GROUP_SUCCESS,
    CREATE_GROUP_FAILURE,
    REQUEST_EDITING_GROUP,
    EDIT_GROUP_SUCCESS,
    EDIT_GROUP_FAILURE,
    REQUEST_EDITING_MULTI_GROUPS,
    EDIT_MULTI_GROUPS_SUCCESS,
    EDIT_MULTI_GROUPS_FAILURE,

    REQUEST_CATEGORIES,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORIES_FAILURE,
    REQUEST_GROUP_CATEGORIES,
    FETCH_GROUP_CATEGORIES_SUCCESS,
    FETCH_GROUP_CATEGORIES_FAILURE,
    SELECT_CATEGORY,
    SELECT_CATEGORY_B2B,
    RESET_CURRENT_CATEGORY,
    RESET_CURRENT_CATEGORY_B2B,
    REQUEST_CREATING_CATEGORY,
    CREATE_CATEGORY_SUCCESS,
    CREATE_CATEGORY_FAILURE,
    REQUEST_EDITING_CATEGORY,
    EDIT_CATEGORY_SUCCESS,
    EDIT_CATEGORY_FAILURE,
    REQUEST_EDITING_MULTI_CATEGORIES,
    EDIT_MULTI_CATEGORIES_SUCCESS,
    EDIT_MULTI_CATEGORIES_FAILURE,
    RESET_CATEGORY,
    RESET_GROUP_AND_CATEGORY,

    REQUEST_CATEGORIES_2,
    FETCH_CATEGORIES_2_SUCCESS,
    FETCH_CATEGORIES_2_FAILURE,
    REQUEST_EDITING_MULTI_CATEGORIES_2,
    EDIT_MULTI_CATEGORIES_2_SUCCESS,
    EDIT_MULTI_CATEGORIES_2_FAILURE,
    REQUEST_DELETE_CATEGORY_2,
    DELETE_CATEGORY_2_SUCCESS,
    DELETE_CATEGORY_2_FAILURE,
    CLEAR_CATEGORY_2_STATUS,

    REQUEST_CATEGORIES_2_B2B,
    FETCH_CATEGORIES_2_SUCCESS_B2B,
    FETCH_CATEGORIES_2_FAILURE_B2B,
    REQUEST_EDITING_MULTI_CATEGORIES_2_B2B,
    EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B,
    EDIT_MULTI_CATEGORIES_2_FAILURE_B2B,
    REQUEST_DELETE_CATEGORY_2_B2B,
    DELETE_CATEGORY_2_SUCCESS_B2B,
    DELETE_CATEGORY_2_FAILURE_B2B,
    CLEAR_CATEGORY_2_STATUS_B2B,
    REQUEST_CATEGORY2_PRODUCTS_B2B,
    FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B,
    FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B,
    RESET_CATEGORY2_ID,

    REQUEST_PRICELEVELS,
    FETCH_PRICELEVELS_SUCCESS,
    FETCH_PRICELEVELS_FAILURE,
    REQUEST_EDITING_MULTI_PRICELEVELS,
    EDIT_MULTI_PRICELEVELS_SUCCESS,
    EDIT_MULTI_PRICELEVELS_FAILURE,

    REQUEST_TYPES,
    FETCH_TYPES_SUCCESS,
    FETCH_TYPES_FAILURE,
    REQUEST_PRODUCT_INFO,
    FETCH_PRODUCT_INFO_SUCCESS,
    FETCH_PRODUCT_INFO_FAILURE,
    REQUEST_SIMPLIFIED_PRODUCTS,
    FETCH_SIMPLIFIED_PRODUCTS_SUCCESS,
    FETCH_SIMPLIFIED_PRODUCTS_FAILURE,

    REQUEST_PRODUCT_BY_NUM,
    FETCH_PRODUCT_BY_NUM_SUCCESS,
    FETCH_PRODUCT_BY_NUM_FAILURE,

    REQUEST_NEXT_PRODUCT,
    FETCH_NEXT_PRODUCT_SUCCESS,
    FETCH_NEXT_PRODUCT_FAILURE,
    REQUEST_PREVIOUS_PRODUCT,
    FETCH_PREVIOUS_PRODUCT_SUCCESS,
    FETCH_PREVIOUS_PRODUCT_FAILURE,

    REQUEST_DELETE_CATEGORY,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_FAILURE,
    REQUEST_DELETE_GROUP,
    DELETE_PRODUCT_GROUP_SUCCESS,
    DELETE_GROUP_FAILURE,
    CLEAR_CATEGORY_STATUS,
    CLEAR_GROUP_STATUS,
    REINITIALZIE_PRODUCT_FORM,

    REQUEST_SMALL_PRODUCT_INFO,
    FETCH_SMALL_PRODUCT_INFO_SUCCESS,
    FETCH_SMALL_PRODUCT_INFO_FAILURE,
    CLEAR_SMALL_PRODUCT,

    REQUEST_CRV_VALUES,
    FETCH_CRV_VALUES_SUCCESS,
    FETCH_CRV_VALUES_FAILURE,

    ATTACH_PRODUCT_IMAGE,
    ATTACH_PRODUCT_IMAGE_SUCCESS,
    ATTACH_PRODUCT_IMAGE_FAILURE,
    CLEAR_ATTACHED_PRODUCT_IMAGE,
    SET_CURRENT_PRODUCT,
    FETCH_RELATED_PRODUCTS,
    FETCH_RELATED_PRODUCTS_SUCCESS,
    FETCH_RELATED_PRODUCTS_FAILURE,
    FETCH_SUGGESTED_PROD_NUM,
    FETCH_SUGGESTED_PROD_NUM_SUCCESS,
    FETCH_SUGGESTED_PROD_NUM_FAILURE,

    FETCH_SUGGEST_DIGIT,
    FETCH_SUGGEST_DIGIT_SUCCESS,
    FETCH_SUGGEST_DIGIT_FAILURE,
    CLEAR_SUGGEST_DIGIT,
    FETCH_PACKAGE_TYPES,
    FETCH_PACKAGE_TYPES_SUCCESS,
    FETCH_PACKAGE_TYPES_FAILURE,
    EDIT_PACKAGE_TYPE,
    EDIT_PACKAGE_TYPE_SUCCESS,
    EDIT_PACKAGE_TYPE_FAILURE,
    REQUEST_DELETE_PACKAGE_TYPE,
    DELETE_PACKAGE_TYPE_SUCCESS,
    DELETE_PACKAGE_TYPE_FAILURE,
    CLEAR_PACKAGE_TYPE_EDITED,
    FETCH_MEASUREMENT_UNIT,
    FETCH_MEASUREMENT_UNIT_SUCCESS,
    FETCH_MEASUREMENT_UNIT_FAILURE,
    EDIT_MEASUREMENT_UNIT,
    EDIT_MEASUREMENT_UNIT_SUCCESS,
    EDIT_MEASUREMENT_UNIT_FAILURE,
    CLEAR_MEASUREMENT_UNIT_EDITED,
    REQUEST_DELETE_MEASUREMENT_UNIT,
    DELETE_MEASUREMENT_UNIT_SUCCESS,
    DELETE_MEASUREMENT_UNIT_FAILURE,
    FETCH_CONVERTABLE_PRODUCTS,
    FETCH_CONVERTABLE_PRODUCTS_SUCCESS,
    FETCH_CONVERTABLE_PRODUCTS_FAILURE,
    ATTACH_DOCUMENT,
    ATTACH_DOCUMENT_SUCCESS,
    ATTACH_DOCUMENT_FAILURE,
    FETCH_CATEGORY2_PRODUCTS_SUCCESS,
    FETCH_CATEGORY2_PRODUCTS_FAILURE,
    REQUEST_CATEGORY2_PRODUCTS,
    DELETE_CATEGORY2_PRODUCT,
    DELETE_CATEGORY2_PRODUCT_SUCCESS,
    DELETE_CATEGORY2_PRODUCT_FAILURE,
    REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT,
    CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS,
    CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE,

    // Default buyer
    REQUEST_DEFAULT_BUYERS,
    REQUEST_DEFAULT_BUYERS_SUCCESS,
    REQUEST_DEFAULT_BUYERS_FAILURE,

    REQUEST_UPDATE_PRODUCT,
    UPDATE_PRODUCT_SUCCEESS,
    UPDATE_PRODUCT_FAILURE,

    SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS,
    SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE,
    REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT,
    DELETE_PRODUCT,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILURE,

    REQUEST_INITIALIZE_ESL,
    REQUEST_DELETE_ESL,
    REQUEST_FETCH_ESL_TEMPLATE,
    REQUEST_SAVE_ESL,
    REQUEST_FETCH_ESL,
    PRODUCTFORM_ACTIVE_CUSTOMER,
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    allByVendor: [],
    currentProduct: null,
    currentProductDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    multiIsEditing: false,
    multiEditError: null,
    multiEdited: false,
    groups: null,
    groupIsLoading: false,
    groupError: null,
    currentGroup: null,
    groupIsCreating: false,
    groupCreateError: null,
    groupCreated: false,
    groupIsEditing: false,
    groupEditError: null,
    groupEdited: false,
    multiGroupIsEditing: false,
    multiGroupEditError: null,
    multiGroupEdited: false,
    categories: [],
    categoryIsLoading: false,
    categoryError: null,
    currentCategory: null,
    currentCategoryB2B: null,
    categoryIsCreating: false,
    categoryCreateError: null,
    categoryCreated: false,
    categoryIsEditing: false,
    categoryEditError: null,
    categoryEdited: false,

    categories_2: [],
    category_2Error: null,
    category_2IsLoading: false,
    multiCategory_2IsEditing: false,
    multiCategory_2EditError: null,
    multiCategory_2Edited: false,

    categories2B2B: [],
    category2ErrorB2B: null,
    category2IsLoadingB2B: false,
    multiCategory2IsEditingB2B: false,
    multiCategory2EditErrorB2B: null,
    multiCategory2EditedB2B: false,

    display_categories: null,
    display_categories_error: null,
    displayCategoriesIsLoading: false,
    editCategoryLoading: false,

    priceLevels: [],
    priceLevelIsLoading: false,
    priceLevelError: null,
    multiPriceLevelIsEditing: false,
    multiPriceLevelEditError: null,
    multiPriceLevelEdited: false,
    types: [],
    typeIsLoading: false,
    typeError: null,
    multiCategoryIsEditing: false,
    multiCategoryEditError: null,
    multiCategoryEdited: false,
    productInfo: null,
    productInfoError: null,
    productInfoIsLoading: false,
    simplifiedProducts: [],
    simplifiedProductsIsLoading: false,
    simplifiedProductsError: null,
    groupCategories: [],
    groupCategoryError: null,
    groupCategoryIsLoading: false,
    deletingCategory: false,
    deleteCategorySuccess: null,
    deleteCategoryError: null,
    deletingGroup: false,
    deleteGroupSuccess: null,
    deleteGroupError: null,
    smallProductDetail: null,
    smallProductDetailIsLoading: false,
    smallProductDetailError: null,
    CRVs: [],
    CRVsIsLoading: false,
    CRVsError: null,
    currentCategoryGroup: null,
    productSaved: null,
    product: null,
    fetchingRelatedProducts: false,
    relatedProductsFetched: false,
    relatedProductsFetchError: null,
    fetchingSuggestDigit: false,
    suggestDigitFetched: null,
    suggestDigitFetchError: null,

    // Buyer Details
    defaultBuyers: [],
    defaultBuyersIsLoading: false,
    defaultBuyersError: null,

    fetchingPackageTypes: false,
    packageTypesFetched: false,
    packageTypeFetchError: null,
    editingPackageTypes: false,
    packageTypesEdited: false,
    packageTypeEditError: null,
    deletingPackageTypes: false,
    deletePackageTypesSuccess: null,
    deletePackageTypesError: null,
    fetchingMeasurementUnit: false,
    measurementUnitFetched: false,
    measurementUnitFetchError: null,
    editingMeasurementUnit: false,
    measurementUnitEdited: false,
    measurementUnitEditError: null,
    deletingMeasurementUnit: false,
    deleteMeasurementUnitSuccess: null,
    deleteMeasurementUnitError: null,
    fetchingConvertableProducts: false,
    convertableProductsFetched: null,
    convertableProductsFetchError: null,


    isAttachingDocument: false,
    attachDocumentError: null,
    attachDocumentSuccess: false,
    category2ProductsIsLoading: false,
    category2ProductsIsLoadingB2B: false,
    requestCategory2ProductsSuccess: false,
    requestCategory2ProductsSuccessB2B: false,
    requestCategory2ProductsError: null,
    requestCategory2ProductsErrorB2B: null,
    category2Id: null,
    category2IdB2B: null,
    category2Products: null,
    category2ProductsB2B: null,
    deletingCategory2Product: false,
    deleteCategory2ProductSuccess: false,
    deleteCategory2ProductError: null,

    continuingOrDiscontinuingProduct: false,
    continueOrDiscontinueProductError: false,
    continueOrDiscontinueProductSuccess: false,

    updateProduct: null,
    updateProductIsLoading: false,
    updateProductError: null,

    savingMobileDescriptionText: false,
    saveMobileDescriptionTextSuccess: false,
    saveMobileDescriptionTextError: null,
    deleteProduct: false,
    deleteProductSuccess: false,
    deleteProductError: null,
    customers: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        // Product action handlers
        case PRODUCTFORM_ACTIVE_CUSTOMER:
          return {
            ...state,
            customers: action.payload,
          }
        case REQUEST_INITIALIZE_ESL:
            return { ...state };
        case REQUEST_DELETE_ESL:
            return { ...state };
        case REQUEST_FETCH_ESL_TEMPLATE:
            return { ...state };
        case REQUEST_SAVE_ESL:
            return { ...state };
        case REQUEST_FETCH_ESL:
            return { ...state };
        case REQUEST_PRODUCTS:
            return { ...state, error: null, isLoading: true, multiPriceLevelIsEditing: false, multiPriceLevelEditError: null, multiPriceLevelEdited: false };
        case FETCH_PRODUCTS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_PRODUCTS_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case REQUEST_PRODUCTS_BY_VENDOR:
            return { ...state, error: null, isLoading: true };
        case FETCH_PRODUCTS_BY_VENDOR_SUCCESS:
            return { ...state, allByVendor: action.payload.data, error: null, isLoading: false };
        case FETCH_PRODUCTS_BY_VENDOR_FAILURE:
            const byVendorError = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: byVendorError, isLoading: false };
        case SELECT_PRODUCT:
            return {...state, currentProduct: action.payload };
        case RESET_CURRENT_PRODUCT:
            return { ...state, currentProduct: null, currentProductDetail: null };
        case CLEAR_CURRENT_PRODUCT:
            return { ...state, currentProduct: null };
        case SET_GROUP_CATEGORY:
            return { ...state, currentCategoryGroup: action.payload};
        case REQUEST_CREATING_PRODUCT:
            return { ...state, isCreating: true, createError: null, created: false };
        case CREATE_PRODUCT_SUCCESS:
            return { ...state, isCreating: false, createError: null, created: true, productSaved: action.payload.data };
        case CREATE_PRODUCT_FAILURE:
            const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, createError: createError, created: false };
        case REQUEST_EDITING_PRODUCT:
            return { ...state, isEditing: true, editError: null, edited: false };
        case EDIT_PRODUCT_SUCCESS:
            return { ...state, isEditing: false, editError: null, edited: true, productSaved: action.payload.data };
        case EDIT_PRODUCT_FAILURE:
            const editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isEditing: false, editError: editError, edited: false };
        case REQUEST_EDITING_MULTI_PRODUCT:
            return { ...state, multiIsEditing: true, multiEditError: null, multiEdited: false };
        case EDIT_MULTI_PRODUCT_SUCCESS:
            return { ...state, multiIsEditing: false, multiEditError: null, multiEdited: true };
        case EDIT_MULTI_PRODUCT_FAILURE:
            const multiEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, multiIsEditing: false, multiEditError: multiEditError, multiEdited: false };
        case REQUEST_PRODUCT_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_PRODUCT_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentProductDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_PRODUCT_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_DISPLAY_CATEGORIES:
            return { ...state, display_categories_error: null, displayCategoriesIsLoading: true };
        case FETCH_DISPLAY_CATEGORIES_SUCCESS:
            return { ...state, display_categories: action.payload, display_categories_error: null, displayCategoriesIsLoading: false };
        case FETCH_DISPLAY_CATEGORIES_FAILURE:
            const display_categories_error = action.payload || { message: action.payload.message };
            return { ...state, display_categories_error: display_categories_error, displayCategoriesIsLoading: false };
        case REQUEST_EDIT_DISPLAY_CATEGORIES:
            return { ...state, editCategoryLoading: true };
        case EDIT_DISPLAY_CATEGORIES_SUCCESS:
            // console.log('success', action.payload.data)
            alert('Display Categories Saved Successfully');
            return { ...state, editCategoryLoading: false };
        case EDIT_DISPLAY_CATEGORIES_FAILURE:
            // console.log('error', action.payload.data)
            alert(action.payload.data.detail);
            return { ...state, editCategoryLoading: false };
        case REQUEST_PRODUCT_BY_NUM:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_PRODUCT_BY_NUM_SUCCESS:
            console.log("payload 2", action.payload.data[0])
            return { ...state, currentProduct: action.payload.data[0], detailIsLoading: false };
        case FETCH_PRODUCT_BY_NUM_FAILURE:
            const detailsError = action.payload.data || { message: action.payload.message };
            return { ...state, detailError: detailsError, detailIsLoading: false };
        case REQUEST_NEXT_PRODUCT:
            return { ...state, detailIsLoading: true, detailError: null };
        case FETCH_NEXT_PRODUCT_SUCCESS:
            return { ...state, currentProduct: action.payload.data, detailIsLoading: false };
        case FETCH_NEXT_PRODUCT_FAILURE:
            const nextDetailError = action.payload.data || { message: action.payload.message };
            return { ...state, detailError: nextDetailError, detailIsLoading: false };
        case REQUEST_PREVIOUS_PRODUCT:
            return { ...state, detailIsLoading: true, detailError: null };
        case FETCH_PREVIOUS_PRODUCT_SUCCESS:
            return { ...state, currentProduct: action.payload.data, detailIsLoading: false };
        case FETCH_PREVIOUS_PRODUCT_FAILURE:
            const prevDetailError = action.payload.data || { message: action.payload.message };
            return { ...state, detailError: prevDetailError, detailIsLoading: false };

        // Group action handlers
        case REQUEST_GROUPS:
            return { ...state, groupError: null, groupIsLoading: true, groups: null, categories: [] };
        case FETCH_GROUPS_SUCCESS:
            return { ...state, groups: action.payload.data, groupError: null, groupIsLoading: false };
        case FETCH_GROUPS_FAILURE:
            const groupError = action.payload || { message: action.payload.message };
            alert(JSON.stringify(groupError));
            return { ...state, groups: null, groupError: groupError, groupIsLoading: false };
        case SELECT_GROUP:
            return {...state, currentGroup: action.payload };
        case RESET_CURRENT_GROUP:
            return { ...state, currentGroup: null };
        case RESET_GROUP_AND_CATEGORY:
            return {...state, groups: null, groupCategories: []}
        case REQUEST_CREATING_GROUP:
            return { ...state, groupIsCreating: true, groupCreateError: null, groupCreated: false };
        case CREATE_GROUP_SUCCESS:
            return { ...state, groupIsCreating: false, groupCreateError: null, groupCreated: true };
        case CREATE_GROUP_FAILURE:
            const groupCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, groupIsCreating: false, groupCreateError: groupCreateError, groupCreated: false };
        case REQUEST_EDITING_GROUP:
            return { ...state, groupIsEditing: true, groupEditError: null, groupEdited: false };
        case EDIT_GROUP_SUCCESS:
            return { ...state, groupIsEditing: false, groupEditError: null, groupEdited: true };
        case EDIT_GROUP_FAILURE:
            const groupEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, groupIsEditing: false, groupEditError: groupEditError, groupEdited: false };
        case REQUEST_EDITING_MULTI_GROUPS:
            return { ...state, multiGroupIsEditing: true, multiGroupEditError: null, multiGroupEdited: false };
        case EDIT_MULTI_GROUPS_SUCCESS:
            return { ...state, multiGroupIsEditing: false, multiGroupEditError: null, multiGroupEdited: true };
        case EDIT_MULTI_GROUPS_FAILURE:
            const multiGroupEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, multiGroupIsEditing: false, multiGroupEditError: multiGroupEditError, multiGroupEdited: false };

        // Category action handlers
        case REQUEST_CATEGORIES:
            return { ...state, groups: null, categories: [], categoryError: null, categoryIsLoading: true };
        case FETCH_CATEGORIES_SUCCESS:
            return { ...state, categories: action.payload.data, categoryError: null, categoryIsLoading: false };
        case FETCH_CATEGORIES_FAILURE:
            const categoryError = action.payload || { message: action.payload.message };
            return { ...state, categories: [], categoryError: categoryError, categoryIsLoading: false };
        case REQUEST_GROUP_CATEGORIES:
            return { ...state, groupCategories: [], groupCategoryError: null, groupCategoryIsLoading: true };
        case FETCH_GROUP_CATEGORIES_SUCCESS:
            return { ...state, groupCategories: action.payload.data, groupCategoryError: null, groupCategoryIsLoading: false };
        case FETCH_GROUP_CATEGORIES_FAILURE:
            const groupCategoryError = action.payload || { message: action.payload.message };
            alert(JSON.stringify(groupCategoryError));
            return { ...state, groupCategories: [], groupCategoryError: groupCategoryError, groupCategoryIsLoading: false };

        case SELECT_CATEGORY:
            return { ...state, currentCategory: action.payload };
        case SELECT_CATEGORY_B2B:
            return { ...state, currentCategoryB2B: action.payload };
        case RESET_CURRENT_CATEGORY:
            return { ...state, currentCategory: null };
        case RESET_CURRENT_CATEGORY_B2B:
            return { ...state, currentCategoryB2B: null };
        case REQUEST_CREATING_CATEGORY:
            return { ...state, categoryIsCreating: true, categoryCreateError: null, categoryCreated: false };
        case CREATE_CATEGORY_SUCCESS:
            return { ...state, categoryIsCreating: false, categoryCreateError: null, categoryCreated: true };
        case CREATE_CATEGORY_FAILURE:
            const categoryCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, categoryIsCreating: false, categoryCreateError: categoryCreateError, categoryCreated: false };
        case REQUEST_EDITING_CATEGORY:
            return { ...state, categoryIsEditing: true, categoryEditError: null, categoryEdited: false };
        case EDIT_CATEGORY_SUCCESS:
            return { ...state, categoryIsEditing: false, categoryEditError: null, categoryEdited: true };
        case EDIT_CATEGORY_FAILURE:
            const categoryEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, categoryIsEditing: false, categoryEditError: categoryEditError, categoryEdited: false };
        case REQUEST_EDITING_MULTI_CATEGORIES:
            return { ...state, multiCategoryIsEditing: true, multiCategoryEditError: null, multiCategoryEdited: false };
        case EDIT_MULTI_CATEGORIES_SUCCESS:
            return { ...state, multiCategoryIsEditing: false, multiCategoryEditError: null, multiCategoryEdited: true };
        case EDIT_MULTI_CATEGORIES_FAILURE:
            const multiCategoryEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, multiCategoryIsEditing: false, multiCategoryEditError: multiCategoryEditError, multiCategoryEdited: false };
        case RESET_CATEGORY:
            return {...state, categoryIsEditing: false, categoryEditError: null, categoryEdited: false, categoryIsCreating: false, categoryCreateError: null, categoryCreated: false }

        case REQUEST_CATEGORIES_2:
            return { ...state, categories2: [], category2Error: null, category2IsLoading: true };
        case FETCH_CATEGORIES_2_SUCCESS:
            return { ...state, categories2: action.payload.data, category2Error: null, category2IsLoading: false };
        case FETCH_CATEGORIES_2_FAILURE:
            const category2Error = action.payload || { message: action.payload.message };
            return { ...state, categories2: [], category2Error: category2Error, category2IsLoading: false };
        case REQUEST_EDITING_MULTI_CATEGORIES_2:
            return { ...state, multiCategory2IsEditing: true, multiCategory2EditError: null, multiCategory2Edited: false, category2ImageAttached: false };
        case EDIT_MULTI_CATEGORIES_2_SUCCESS:
            return { ...state, multiCategory2IsEditing: false, multiCategory2EditError: null, multiCategory2Edited: true };
        case EDIT_MULTI_CATEGORIES_2_FAILURE:
            const multiCategory2EditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            alert(JSON.stringify(multiCategory2EditError));
            return { ...state, multiCategory2IsEditing: false, multiCategory2EditError: multiCategory2EditError, multiCategory2Edited: false };

        case REQUEST_DELETE_CATEGORY_2:
            return { ...state, deletingCategory2: true, deleteCategory2Success: null, deleteCategory2Error: null };
        case DELETE_CATEGORY_2_SUCCESS:
            return { ...state, deletingCategory2: false, deleteCategory2Success: true };
        case DELETE_CATEGORY_2_FAILURE:
            const deleteCategory2Error = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(deleteCategory2Error));
            return { ...state, deletingCategory2: false, deleteCategory2Error: deleteCategory2Error };
        case CLEAR_CATEGORY_2_STATUS:
            return {
              ...state,
              deletingCategory2: false,
              deleteCategory2Success: null,
              deleteCategory2Error: null,
              multiCategory2IsEditing: false,
              multiCategory2EditError: null,
              multiCategory2Edited: false,
              savingCategory2Image: false,
              category2ImageAttached: false,
              category2ImageAttachError: null,
            };

        // Category B2B action handlers
        case REQUEST_CATEGORIES_2_B2B:
            return { ...state, categories2B2B: [], category2ErrorB2B: null, category2IsLoadingB2B: true };
        case FETCH_CATEGORIES_2_SUCCESS_B2B:
            return { ...state, categories2B2B: action.payload.data, category2ErrorB2B: null, category2IsLoadingB2B: false };
        case FETCH_CATEGORIES_2_FAILURE_B2B:
            const category2ErrorB2B = action.payload || { message: action.payload.message };
            return { ...state, categories2B2B: [], category2ErrorB2B: category2ErrorB2B, category2IsLoadingB2B: false };
        case REQUEST_EDITING_MULTI_CATEGORIES_2_B2B:
            return { ...state, multiCategory2IsEditingB2B: true, multiCategory2EditErrorB2B: null, multiCategory2EditedB2B: false, category2ImageAttachedB2B: false };
        case EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B:
            return { ...state, multiCategory2IsEditingB2B: false, multiCategory2EditErrorB2B: null, multiCategory2EditedB2B: true };
        case EDIT_MULTI_CATEGORIES_2_FAILURE_B2B:
            const multiCategory2EditErrorB2B = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            alert(JSON.stringify(multiCategory2EditErrorB2B));
            return { ...state, multiCategory2IsEditingB2B: false, multiCategory2EditErrorB2B: multiCategory2EditErrorB2B, multiCategory2EditedB2B: false };

        case REQUEST_DELETE_CATEGORY_2_B2B:
            return { ...state, deletingCategory2B2B: true, deleteCategory2SuccessB2B: null, deleteCategory2ErrorB2B: null };
        case DELETE_CATEGORY_2_SUCCESS_B2B:
            return { ...state, deletingCategory2B2B: false, deleteCategory2SuccessB2B: true };
        case DELETE_CATEGORY_2_FAILURE_B2B:
            const deleteCategory2ErrorB2B = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(deleteCategory2ErrorB2B));
            return { ...state, deletingCategory2B2B: false, deleteCategory2ErrorB2B: deleteCategory2ErrorB2B };
        case CLEAR_CATEGORY_2_STATUS_B2B:
            return {
                ...state,
                deletingCategory2B2B: false,
                deleteCategory2SuccessB2B: null,
                deleteCategory2ErrorB2B: null,
                multiCategory2IsEditingB2B: false,
                multiCategory2EditErrorB2B: null,
                multiCategory2EditedB2B: false,
                savingCategory2ImageB2B: false,
                category2ImageAttachedB2B: false,
                category2ImageAttachErrorB2B: null,
            };

        // PriceLevel action handlers
        case REQUEST_PRICELEVELS:
            return { ...state, priceLevelError: null, priceLevelIsLoading: true, multiPriceLevelIsEditing: false, multiPriceLevelEditError: null, multiPriceLevelEdited: false };
        case FETCH_PRICELEVELS_SUCCESS:
            return { ...state, priceLevels: action.payload.data, priceLevelError: null, priceLevelIsLoading: false };
        case FETCH_PRICELEVELS_FAILURE:
            const priceLevelError = action.payload || { message: action.payload.message };
            return { ...state, priceLevels: [], priceLevelError: priceLevelError, priceLevelIsLoading: false };
        case REQUEST_EDITING_MULTI_PRICELEVELS:
            return { ...state, multiPriceLevelIsEditing: true, multiPriceLevelEditError: null, multiPriceLevelEdited: false };
        case EDIT_MULTI_PRICELEVELS_SUCCESS:
            return { ...state, multiPriceLevelIsEditing: false, multiPriceLevelEditError: null, multiPriceLevelEdited: true };
        case EDIT_MULTI_PRICELEVELS_FAILURE:
            const multiPriceLevelEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, multiPriceLevelIsEditing: false, multiPriceLevelEditError: multiPriceLevelEditError, multiPriceLevelEdited: false };

        // Type action handlers
        case REQUEST_TYPES:
            return { ...state, typeError: null, typeIsLoading: true };
        case FETCH_TYPES_SUCCESS:
            return { ...state, types: action.payload.data, typeError: null, typeIsLoading: false };
        case FETCH_TYPES_FAILURE:
            const typeError = action.payload || { message: action.payload.message };
            return { ...state, types: [], typeError: typeError, typeIsLoading: false };

        case REQUEST_PRODUCT_INFO:
            return { ...state, productInfoError: null, productInfoIsLoading: true };
        case FETCH_PRODUCT_INFO_SUCCESS:
            return { ...state, productInfo: action.payload.data, productInfoError: null, productInfoIsLoading: false };
        case FETCH_PRODUCT_INFO_FAILURE:
            const productInfoError = action.payload.data || { message: action.payload.message };
            return { ...state, productInfo: null, productInfoError: productInfoError, productInfoIsLoading: false };


        case DELETE_PRODUCT: 
            return { ...state, deleteProduct: true, deleteProductSuccess: true, deleteProductError: false };
        case DELETE_PRODUCT_SUCCESS: 
            return { ...state, deleteProduct: true, deleteProductSuccess: true, deleteProductError: false };
        case DELETE_PRODUCT_FAILURE: 
            const deleteProductInfoError = action.payload.data || {message: action.payload.message};
            return { ...state, deleteProduct: false, deleteProductSuccess: false, deleteProductError: deleteProductInfoError };

        case REQUEST_SIMPLIFIED_PRODUCTS:
            return { ...state, simplifiedProductsIsLoading: true, simplifiedProductsError: null, simplifiedProducts: [] };
        case FETCH_SIMPLIFIED_PRODUCTS_SUCCESS:
            return { ...state, simplifiedProductsIsLoading: false, simplifiedProducts: action.payload.data };
        case FETCH_SIMPLIFIED_PRODUCTS_FAILURE:
            const simplifiedProductsError = action.payload.data || { message: action.payload.message };
            return { ...state, simplifiedProductsIsLoading: false, simplifiedProductsError: simplifiedProductsError };

        case REQUEST_DELETE_CATEGORY:
            return { ...state, deletingCategory: true, deleteCategorySuccess: null, deleteCategoryError: null };
        case DELETE_CATEGORY_SUCCESS:
            return { ...state, deletingCategory: false, deleteCategorySuccess: true };
        case DELETE_CATEGORY_FAILURE:
            const deleteCategoryError = action.payload.data || { message: action.payload.message };
            return { ...state, deletingCategory: false, deleteCategoryError: deleteCategoryError };
        case CLEAR_GROUP_STATUS:
            return { ...state, deleteCategoryError: null, deleteCategorySuccess: null };

        case REQUEST_DELETE_GROUP:
            return { ...state, deletingGroup: true, deleteGroupSuccess: null, deleteGroupError: null };
        case DELETE_PRODUCT_GROUP_SUCCESS:
            return { ...state, deletingGroup: false, deleteGroupSuccess: true };
        case DELETE_GROUP_FAILURE:
            const deleteGroupError = action.payload.data || { message: action.payload.messge };
            return { ...state, deletingGroup: false, deleteGroupError: deleteGroupError };
        case CLEAR_GROUP_STATUS:
            return { ...state, deleteGroupError: null, deleteGroupSuccess: null };

        case REINITIALZIE_PRODUCT_FORM:
            return { ...state, currentProduct: action.payload };

        case REQUEST_SMALL_PRODUCT_INFO:
            return { ...state, smallProductDetailIsLoading: true, smallProductDetail: null, smallProductDetailError: null };
        case FETCH_SMALL_PRODUCT_INFO_SUCCESS:
            return { ...state, smallProductDetailIsLoading: false, smallProductDetail: action.payload.data };
        case FETCH_SMALL_PRODUCT_INFO_FAILURE:
            const smallProductDetailError = action.payload.data || { message: action.payload.message };
            return { ...state, smallProductDetailIsLoading: false, smallProductDetailError: smallProductDetailError };
        case CLEAR_SMALL_PRODUCT:
            return { ...state, smallProductDetail: null, smallProductDetailError: null };

        case REQUEST_CRV_VALUES:
            return { ...state, CRVsIsLoading: true, CRVs: [], CRVsError: null };
        case FETCH_CRV_VALUES_SUCCESS:
            return { ...state, CRVsIsLoading: false, CRVs: action.payload.data };
        case FETCH_CRV_VALUES_FAILURE:
            const CRVsError = action.payload.data || { message: action.payload.message };
            return { ...state, CRVsIsLoading: false, CRVsError: CRVsError };

        case REQUEST_DEFAULT_BUYERS:
          return { ...state, defaultBuyersIsLoading: true, defaultBuyers: [], defaultBuyersError: null };
        case REQUEST_DEFAULT_BUYERS_SUCCESS:
          return { ...state, defaultBuyersIsLoading: false, defaultBuyers: action.payload.data };
        case REQUEST_DEFAULT_BUYERS_FAILURE:
          const defaultBuyersError = action.payload.data || { message: action.payload.message };
          return { ...state, defaultBuyersIsLoading: false, defaultBuyersError: defaultBuyersError}

        case ATTACH_PRODUCT_IMAGE:
            return { ...state, attachingProductImage: true, productImageAttached: false, productImageAttachError: null };
        case ATTACH_PRODUCT_IMAGE_SUCCESS:
            return { ...state, attachingProductImage: false, productImageAttached: true, productImageAttachError: null };
        case ATTACH_PRODUCT_IMAGE_FAILURE:
            const productImageAttachError = action.payload.data || { message: action.payload.message };
            return { ...state, attachingProductImage: false, productImageAttached: false, productImageAttachError: productImageAttachError };
        case CLEAR_ATTACHED_PRODUCT_IMAGE:
            return { ...state, attachingProductImage: false, productImageAttached: false, productImageAttachError: null };
        case SET_CURRENT_PRODUCT:
            return { ...state, product: action.payload}
        case FETCH_RELATED_PRODUCTS:
            return { ...state, fetchingRelatedProducts: true, relatedProductsFetched: false, relatedProductsFetchError: null };
        case FETCH_RELATED_PRODUCTS_SUCCESS:
            return { ...state, fetchingRelatedProducts: false, relatedProductsFetched: action.payload.data, relatedProductsFetchError: null };
        case FETCH_RELATED_PRODUCTS_FAILURE:
            const relatedProductsFetchError = action.payload.data || { message: action.payload.message };
            return { ...state, fetchingRelatedProducts: false, relatedProductsFetched: false, relatedProductsFetchError: relatedProductsFetchError };
        case FETCH_SUGGESTED_PROD_NUM:
            return { ...state, fetchingSuggestedProdNum: true, suggestedProdNumFetched: null, suggestedProdNumFetchError: null };
        case FETCH_SUGGESTED_PROD_NUM_SUCCESS:
            return { ...state, fetchingSuggestedProdNum: false, suggestedProdNumFetched: action.payload.data, suggestedProdNumFetchError: null };
        case FETCH_SUGGESTED_PROD_NUM_FAILURE:
            const suggestedProdNumFetchError = action.payload.data || { message: action.payload.message };
            return { ...state, fetchingSuggestedProdNum: false, suggestedProdNumFetchError: suggestedProdNumFetchError };

        case FETCH_SUGGEST_DIGIT:
            return { ...state, fetchingSuggestDigit: true, suggestDigitFetched: false, suggestDigitFetchError: null };
        case FETCH_SUGGEST_DIGIT_SUCCESS:
            return { ...state, fetchingSuggestDigit: false, suggestDigitFetched: action.payload.data, suggestDigitFetchError: null };
        case FETCH_SUGGEST_DIGIT_FAILURE:
            const suggestDigitFetchError = action.payload.data || { message: action.payload.message };
            return { ...state, fetchingSuggestDigit: false, suggestDigitFetched: false, suggestDigitFetchError: suggestDigitFetchError };
        case CLEAR_SUGGEST_DIGIT:
            return { ...state, fetchingSuggestDigit: false, suggestDigitFetched: null, suggestDigitFetchError: null };

        case FETCH_PACKAGE_TYPES:
            return { ...state, fetchingPackageTypes: true, packageTypesFetched: false, packageTypeFetchError: null };
        case FETCH_PACKAGE_TYPES_SUCCESS:
            return { ...state, fetchingPackageTypes: false, packageTypesFetched: action.payload.data, packageTypeFetchError: null };
        case FETCH_PACKAGE_TYPES_FAILURE:
            const packageTypeFetchError = action.payload.data || { message: action.payload.message };
            return { ...state, fetchingPackageTypes: false, packageTypesFetched: false, packageTypeFetchError: packageTypeFetchError };
        case EDIT_PACKAGE_TYPE:
            return { ...state, editingPackageTypes: true, packageTypesEdited: false, packageTypeEditError: null };
        case EDIT_PACKAGE_TYPE_SUCCESS:
            return { ...state, editingPackageTypes: false, packageTypesEdited: true, packageTypeEditError: null };
        case EDIT_PACKAGE_TYPE_FAILURE:
            const packageTypeEditError = action.payload.data || { message: action.data.message };
            return { ...state, editingPackageTypes: false, packageTypesEdited: false, packageTypeEditError: packageTypeEditError };
        case REQUEST_DELETE_PACKAGE_TYPE:
            return { ...state, deletingPackageTypes: true, deletePackageTypesSuccess: null, deletePackageTypesError: null };
        case DELETE_PACKAGE_TYPE_SUCCESS:
            return { ...state, deletingPackageTypes: false, deletePackageTypesSuccess: true, deletePackageTypesError: null };
        case DELETE_PACKAGE_TYPE_FAILURE:
            const deletePackageTypesError = action.payload.data || { message: action.payload.messge };
            return { ...state, deletingPackageTypes: false, deletePackageTypesSuccess: null, deletePackageTypesError: deletePackageTypesError };
        case CLEAR_PACKAGE_TYPE_EDITED:
            return { ...state, editingPackageTypes: false, packageTypesEdited: false, packageTypeEditError: null };
        case FETCH_MEASUREMENT_UNIT:
            return { ...state, fetchingMeasurementUnit: true, measurementUnitFetched: false, measurementUnitFetchError: null };
        case FETCH_MEASUREMENT_UNIT_SUCCESS:
            return { ...state, fetchingMeasurementUnit: false, measurementUnitFetched: action.payload.data, measurementUnitFetchError: null };
        case FETCH_MEASUREMENT_UNIT_FAILURE:
            const measurementUnitFetchError = action.payload.data || { message: action.payload.message };
            return { ...state, fetchingMeasurementUnit: false, measurementUnitFetched: false, measurementUnitFetchError: measurementUnitFetchError };
        case EDIT_MEASUREMENT_UNIT:
            return { ...state, editingMeasurementUnit: true, measurementUnitEdited: false, measurementUnitEditError: null };
        case EDIT_MEASUREMENT_UNIT_SUCCESS:
            return { ...state, editingMeasurementUnit: false, measurementUnitEdited: true, measurementUnitEditError: null };
        case EDIT_MEASUREMENT_UNIT_FAILURE:
            const measurementUnitEditError = action.payload.data || { message: action.payload.message };
            return { ...state, editingMeasurementUnit: false, measurementUnitEdited: false, measurementUnitEditError: measurementUnitEditError };
        case CLEAR_MEASUREMENT_UNIT_EDITED:
            return { ...state, editingMeasurementUnit: false, measurementUnitEdited: false, measurementUnitEditError: null };
        case REQUEST_DELETE_MEASUREMENT_UNIT:
            return { ...state, deletingMeasurementUnit: true, deleteMeasurementUnitSuccess: null, deleteMeasurementUnitError: null };
        case DELETE_MEASUREMENT_UNIT_SUCCESS:
            return { ...state, deletingMeasurementUnit: false, deleteMeasurementUnitSuccess: true, deleteMeasurementUnitError: null };
        case DELETE_MEASUREMENT_UNIT_FAILURE:
            const deleteMeasurementUnitError = action.payload.data || { message: action.payload.messge };
            return { ...state, deletingMeasurementUnit: false, deleteMeasurementUnitSuccess: null, deleteMeasurementUnitError: deleteMeasurementUnitError };
        case FETCH_CONVERTABLE_PRODUCTS:
            return { ...state, fetchingConvertableProducts: true, convertableProductsFetched: null, convertableProductsFetchError: null };
        case FETCH_CONVERTABLE_PRODUCTS_SUCCESS:
            return { ...state, fetchingConvertableProducts: false, convertableProductsFetched: action.payload.data, convertableProductsFetchError: null };
        case FETCH_CONVERTABLE_PRODUCTS_FAILURE:
            const convertableProductsFetchError = action.payload.data || { message: action.payload.message };
            return { ...state, fetchingConvertableProducts: false, convertableProductsFetched: null, convertableProductsFetchError: convertableProductsFetchError };
        case ATTACH_DOCUMENT:
            return {...state, isAttachingDocument: true, attachDocumentError: null, attachDocumentSuccess: false};
        case ATTACH_DOCUMENT_SUCCESS:
            return {...state, isAttachingDocument: false, attachDocumentError: null, attachDocumentSuccess: true};
        case ATTACH_DOCUMENT_FAILURE:
            const attachDocumentError = action.payload.data || {message: action.payload.message};
            return {...state, isAttachingDocument: false, attachDocumentError: attachDocumentError, attachDocumentSuccess: false};
        case REQUEST_CATEGORY2_PRODUCTS:
            return { ...state, category2Id: action.payload, category2ProductsIsLoading: true, requestCategory2ProductsSuccess: null, requestCategory2ProductsError: null };
        case FETCH_CATEGORY2_PRODUCTS_SUCCESS:
            return { ...state, category2Products: action.payload.data, category2ProductsIsLoading: false, requestCategory2ProductsSuccess: true, requestCategory2ProductsError: null };
        case FETCH_CATEGORY2_PRODUCTS_FAILURE:
            const requestCategory2Error = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(requestCategory2Error));
            return { ...state, category2ProductsIsLoading: false, requestCategory2ProductsSuccess: false, requestCategory2ProductsError: null };

        case REQUEST_CATEGORY2_PRODUCTS_B2B:
            return { ...state, category2IdB2B: action.payload, category2ProductsIsLoadingB2B: true, requestCategory2ProductsSuccessB2B: null, requestCategory2ProductsErrorB2B: null };
        case FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B:
            return { ...state, category2ProductsB2B: action.payload.data, category2ProductsIsLoadingB2B: false, requestCategory2ProductsSuccessB2B: true, requestCategory2ProductsErrorB2B: null };
        case FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B:
            const requestCategory2ErrorB2B = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(requestCategory2ErrorB2B));
            return { ...state, category2ProductsIsLoadingB2B: false, requestCategory2ProductsSuccessB2B: false, requestCategory2ProductsErrorB2B: null };
        
        case RESET_CATEGORY2_ID:
            return {...state, category2Id: null, category2IdB2B: null}

        case DELETE_CATEGORY2_PRODUCT:
            return { ...state, deletingCategory2Product: true, deleteCategory2ProductSuccess: false, deleteCategory2ProductError: null };
        case DELETE_CATEGORY2_PRODUCT_SUCCESS:
            return { ...state, deletingCategory2Product: false, deleteCategory2ProductSuccess: true, deleteCategory2ProductError: null };
        case DELETE_CATEGORY2_PRODUCT_FAILURE:
            const deleteCategory2ProductError = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(deleteCategory2ProductError));
            return { ...state, deletingCategory2Product: false, deleteCategory2ProductSuccess: false, deleteCategory2ProductError: null };

        // discontinuing product
        case REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT:
          return { ...state, continuingOrDiscontinuingProduct: true, continueOrDiscontinueProductSuccess: false, continueOrDiscontinueProductError: null };
        case CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS:
          return { ...state, continuingOrDiscontinuingProduct: false, continueOrDiscontinueProductSuccess: true, continueOrDiscontinueProductError: null };
        case CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE:
          return { ...state, continuingOrDiscontinuingProduct: false, continueOrDiscontinueProductSuccess: false, continueOrDiscontinueProductError: action.payload.message };

        case REQUEST_UPDATE_PRODUCT:
            return { ...state, updateProductError: null, updateProductIsLoading: true,  updateProduct: null };
        case UPDATE_PRODUCT_SUCCEESS:
            return { ...state, updateProductError: null, updateProductIsLoading: false,  updateProduct: action.payload };
        case UPDATE_PRODUCT_FAILURE:
            const requestUpdateProductError = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(requestUpdateProductError));
            return { ...state, updateProductError: requestUpdateProductError, updateProductIsLoading: false,  updateProduct: null };
        case REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT:
          return {
            ...state,
            savingMobileDescriptionText: true,
            saveMobileDescriptionTextSuccess: false,
            saveMobileDescriptionTextError: null,
          };
        case SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS:
          return {
            ...state,
            savingMobileDescriptionText: false,
            saveMobileDescriptionTextSuccess: true,
            saveMobileDescriptionTextError: null,
          };
        case SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE: {
          const saveMobileDescriptionTextError = action.payload.data || { message: action.payload.message };
          alert(JSON.stringify(saveMobileDescriptionTextError));
          return {
            ...state,
            savingMobileDescriptionText: false,
            saveMobileDescriptionTextSuccess: false,
            saveMobileDescriptionTextError,
          };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/products_reducer.js